import React from 'react';

import classes from './CancelSubscriptionModal.module.scss';
import Checkbox from '@core/components/checkbox/Checkbox';
import RadioInput from '@core/components/radioinput/RadioInput';
import ActionButton from '@core/components/actionbutton/ActionButton';

const CancelSubscriptionModal = ({cancelReason, setCancelReason ,closeHandler, continueCancelHandler}) => {
    return (
        <div className={classes['wrapper']}>
            <p>We're sorry to see you go, but could you please tell us why? We might be able to help.
                Why are you canceling your subscription? </p>
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'There’s too little learning content',
                    id: `cancel_reason_1`,
                }}
                onChange={()=>setCancelReason('There’s too little learning content')}
                checked={cancelReason==='There’s too little learning content'}
            />
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'I didn’t find any value in Pharmuni',
                    id: `cancel_reason_2`,
                }}
                onChange={()=>setCancelReason('I didn’t find any value in Pharmuni')}
                checked={cancelReason==='I didn’t find any value in Pharmuni'}
            />
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'It’s too expensive',
                    id: `cancel_reason_3`,
                }}
                onChange={()=>setCancelReason('It’s too expensive')}
                checked={cancelReason==='It’s too expensive'}
            />
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'The feature I expected were missing',
                    id: `cancel_reason_4`,
                }}
                onChange={()=>setCancelReason('The feature I expected were missing')}
                checked={cancelReason==='The feature I expected were missing'}
            />
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'Technical difficulties ',
                    id: `cancel_reason_5`,
                }}
                onChange={()=>setCancelReason('Technical difficulties ')}
                checked={cancelReason==='Technical difficulties '}
            />
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'I do not want the plan to auto-renew',
                    id: `cancel_reason_6`,
                }}
                onChange={()=>setCancelReason('I do not want the plan to auto-renew')}
                checked={cancelReason==='I do not want the plan to auto-renew'}
            />
            <RadioInput
                input={{
                    name: `cancel_reason`,
                    label: 'I no longer need it',
                    id: `cancel_reason_7`,
                }}
                onChange={()=>setCancelReason('I no longer need it')}
                checked={cancelReason==='I no longer need it'}
            />
            <div className="d-flex flex-column flex-md-row gap-2 mt-3 justify-content-end">
                <ActionButton kind='secondary' onClick={closeHandler}>Cancel</ActionButton>
                <ActionButton disabled={cancelReason === ''} onClick={continueCancelHandler}>Continue Cancellation</ActionButton>
            </div>
        </div>
    );
};

export default CancelSubscriptionModal;